import { Button, makeStyles, TextField } from '@material-ui/core';
import React, { useEffect } from 'react';
import { AiFillEdit } from 'react-icons/ai';
import { useNavigate, useParams } from 'react-router';

const useStyles = makeStyles({
  table: {
    minWidth: 700,
    maxWidth: '100%',
  },
  TableContainer: {
    maxWidth: '70%',
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-evenly',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    width: '22%',
  },
  input: {
    marginTop: '10px',
  },
  formSpan: {
    marginTop: '10px',
    fontFamily: 'Roboto',
    fontSize: '15px',
    color: '#888',
    textAlign: 'center',
  },
  formButtonsContainer: {
    display: 'flex',
    justifyContent: 'space-around',
    marginTop: '50px',
  },
});

export default function UpdateGlosary() {
  const classes = useStyles();
  const [letter, setLetter] = React.useState('');
  const [word, setWord] = React.useState('');
  const [definition, setDefinition] = React.useState('');
  const [selectedGlosary, setSelectedGlosary] = React.useState(null);
  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    fetch(`https://api.edicionesmilenio.com/api/glosary/${id}`)
      .then((response) => response.json())
      .then((data) => {
        if (data?.data) {
          setLetter(data?.data?.letter);
          setWord(data?.data?.word);
          setDefinition(data?.data?.definition);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const handleUpdate = async () => {
    try {
      let response = await fetch(
        `https://api.edicionesmilenio.com/api/glosary/${id}`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            letter,
            word,
            definition,
          }),
        }
      );

      let data = await response.json();
      if (data.success) {
        navigate('/admin/glosaries', { replace: true });
      } else {
        console.error(data.message);
        window.alert('Error al actualizar el glosario, intente de nuevo');
      }
    } catch (err) {
      console.error(err);
      window.alert('Error al actualizar el glosario, intente de nuevo');
    }
  };

  return (
    <div
      style={{
        width: '100%',
        paddingLeft: '20px',
        paddingRight: '20px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }}
    >
      <p
        style={{
          width: '100%',
          color: '#888',
          marginBottom: '50px',
          alignSelf: 'center',
          justifySelf: 'center',
          textAlign: 'center',
        }}
      >
        Estimado administrador, mediante este formulario usted podrá actualizar
        palabras para el glosario de la plataforma.
      </p>
      <TextField
        className={classes.input}
        id="outlined-basic"
        label="Letra"
        variant="outlined"
        value={letter || ''}
        onChange={(e) => setLetter(e.target.value)}
      />
      <TextField
        className={classes.input}
        id="outlined-basic"
        label="Palabra"
        variant="outlined"
        value={word || ''}
        onChange={(e) => setWord(e.target.value)}
      />
      <TextField
        className={classes.input}
        id="outlined-basic"
        label="Definición"
        variant="outlined"
        value={definition || ''}
        onChange={(e) => setDefinition(e.target.value)}
      />
      <Button
        onClick={() => {
          setSelectedGlosary(null);
          setLetter('');
          setWord('');
          setDefinition('');
        }}
      >
        Limpiar
      </Button>
      <div className={classes.formButtonsContainer}>
        <Button variant="contained" onClick={handleUpdate}>
          <AiFillEdit size={15} />
          Actualizar
        </Button>
      </div>
    </div>
  );
}
